/* Wuffy Lab - shared homepage behaviour */
(function () {
  'use strict';
  if (window.__wlAppInit) { return; }
  window.__wlAppInit = true;

  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  ready(function () {
    var reveals = document.querySelectorAll('.wl-reveal');
    if (reveals.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px' });
        reveals.forEach(function (el) { io.observe(el); });
      } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }
    }

    var hdr = document.querySelector('.wl-header');
    if (hdr) {
      var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); };
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    }

    document.querySelectorAll('[data-wl-acc]').forEach(function (root) {
      root.querySelectorAll('[data-wl-acc-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          var open = btn.getAttribute('aria-expanded') === 'true';
          if (root.hasAttribute('data-wl-acc-single')) {
            root.querySelectorAll('[data-wl-acc-btn]').forEach(function (b) {
              if (b !== btn) {
                b.setAttribute('aria-expanded', 'false');
                var p = document.getElementById(b.getAttribute('aria-controls'));
                if (p) p.style.gridTemplateRows = '0fr';
                var s = b.querySelector('[data-wl-sign]');
                if (s) { if (s.getAttribute('data-wl-sign') === 'rotate') { s.style.transform = 'none'; } else { s.textContent = '+'; } }
              }
            });
          }
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.style.gridTemplateRows = open ? '0fr' : '1fr';
          var sign = btn.querySelector('[data-wl-sign]');
          if (sign) {
            if (sign.getAttribute('data-wl-sign') === 'rotate') { sign.style.transform = open ? 'none' : 'rotate(45deg)'; }
            else { sign.textContent = open ? '+' : '−'; }
          }
        });
      });
    });

    document.querySelectorAll('[data-wl-rail-prev],[data-wl-rail-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-wl-rail-prev') || btn.getAttribute('data-wl-rail-next');
        var rail = document.getElementById(id);
        if (!rail) return;
        var dir = btn.hasAttribute('data-wl-rail-prev') ? -1 : 1;
        rail.scrollBy({ left: dir * Math.min(360, rail.clientWidth * 0.8), behavior: 'smooth' });
      });
    });

    document.querySelectorAll('[data-wl-ann]').forEach(function (bar) {
      var items = [].slice.call(bar.querySelectorAll('[data-wl-ann-item]'));
      if (items.length < 2) return;
      var i = 0, timer = null;
      var show = function (n) { i = (n + items.length) % items.length; items.forEach(function (el, k) { el.hidden = k !== i; }); };
      var play = function () { timer = setInterval(function () { show(i + 1); }, 5000); };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      show(0); play();
      bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', play);
      var p = bar.querySelector('[data-wl-ann-prev]'), n = bar.querySelector('[data-wl-ann-next]');
      if (p) p.addEventListener('click', function () { stop(); show(i - 1); play(); });
      if (n) n.addEventListener('click', function () { stop(); show(i + 1); play(); });
    });

    var navDrawer = document.getElementById('wl-nav-drawer');
    var navOverlay = document.getElementById('wl-nav-overlay');
    var openNav = function () { if (navDrawer) { navDrawer.hidden = false; if (navOverlay) navOverlay.hidden = false; document.body.style.overflow = 'hidden'; } };
    var closeNav = function () { if (navDrawer) { navDrawer.hidden = true; if (navOverlay) navOverlay.hidden = true; document.body.style.overflow = ''; } };
    document.querySelectorAll('[data-wl-nav-open]').forEach(function (b) { b.addEventListener('click', openNav); });
    document.querySelectorAll('[data-wl-nav-close]').forEach(function (b) { b.addEventListener('click', closeNav); });
    if (navOverlay) navOverlay.addEventListener('click', closeNav);

    document.querySelectorAll('[data-wl-mega-root]').forEach(function (root) {
      var btn = root.querySelector('[data-wl-mega-btn]');
      var panel = root.querySelector('[data-wl-mega-panel]');
      if (!btn || !panel) return;
      var set = function (open) { panel.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); };
      root.addEventListener('mouseenter', function () { set(true); });
      root.addEventListener('mouseleave', function () { set(false); });
      btn.addEventListener('click', function () { set(panel.hidden); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    });

    var sticky = document.querySelector('[data-wl-sticky]');
    if (sticky) {
      var hero = document.getElementById('hero');
      sticky.hidden = true;
      if (hero && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { sticky.hidden = es[0].isIntersecting; }, {}).observe(hero);
      } else { sticky.hidden = false; }
      var cs = sticky.querySelector('[data-wl-sticky-close]');
      if (cs) cs.addEventListener('click', function () { sticky.parentNode.removeChild(sticky); });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-wl-atc]') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) { window.location.href = btn.getAttribute('data-url') || '/cart'; return; }
      var label = btn.innerHTML;
      btn.disabled = true; btn.innerHTML = '…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.innerHTML = label; btn.disabled = false; window.location.href = '/cart'; });
    });
  });
})();

/* Wuffy Lab - patte + animations sur tous les boutons CTA */
(function () {
  'use strict';
  if (window.__wlPawInit) { return; }
  window.__wlPawInit = true;
  var PAW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><ellipse cx="5.6" cy="9.6" rx="2" ry="2.6" transform="rotate(-22 5.6 9.6)"/><ellipse cx="18.4" cy="9.6" rx="2" ry="2.6" transform="rotate(22 18.4 9.6)"/><ellipse cx="9.4" cy="5.3" rx="2.1" ry="2.8" transform="rotate(-8 9.4 5.3)"/><ellipse cx="14.6" cy="5.3" rx="2.1" ry="2.8" transform="rotate(8 14.6 5.3)"/><path d="M12 10.3c-2.5 0-4.1 1.7-5.1 3.5-.7 1.2-2.1 2-2.1 3.6 0 1.9 1.5 3.1 3.3 3.1 1.4 0 2.4-.7 3.9-.7s2.5.7 3.9.7c1.8 0 3.3-1.2 3.3-3.1 0-1.6-1.4-2.4-2.1-3.6-1-1.8-2.6-3.5-5.1-3.5z"/></svg>';
  var CTA = '.wl-btn,.wlq-cta,[data-wl-submit],[data-wl-sticky-add],[data-wl-atc],[data-wlq-open],.wl-root button[type="submit"],.wl-root [data-wl-sticky] a';
  var PRIMARY = '.wl-btn--primary,[data-wl-submit],[data-wl-sticky-add],[data-wl-atc],.wl-root button[type="submit"],.wl-root [data-wl-sticky] a';
  var SKIP = '.wlq-opt,.wlq-close,.wlq-back,.wlq-card,[data-wl-qty],[data-wl-thumb],[data-wl-size],[data-wl-acc-btn],[data-wl-mode-toggle],[data-wl-no-paw],[data-wl-zoom],[data-wl-modal-close],[data-wl-sticky-close],[data-wl-pdp-sticky-close],[data-wl-media-prev],[data-wl-media-next],[data-wl-rail-prev],[data-wl-rail-next],[data-wl-ann-prev],[data-wl-ann-next],[data-wl-nav-open],[data-wl-nav-close],[data-wl-mega-btn]';

  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function isCta(el) {
    if (el.matches(SKIP) || el.closest(SKIP)) return false;
    if (el.matches(CTA)) return true;
    if (!el.closest('.wl-root')) return false;
    if (txt(el).length < 2) return false;
    var cs = getComputedStyle(el), h = el.offsetHeight, r = parseFloat(cs.borderTopLeftRadius) || 0;
    return h >= 36 && r >= h / 2 - 1 && el.offsetWidth > h * 1.4 && cs.textTransform === 'uppercase';
  }
  function decorate(el) {
    if (el.getAttribute('data-wl-paw') || el.querySelector('.wl-paw')) return;
    el.setAttribute('data-wl-paw', '1');
    el.classList.add('wl-paw-btn');
    if (el.matches(PRIMARY)) el.classList.add('wl-paw-btn--pulse');
    var cs = getComputedStyle(el);
    if (cs.display !== 'inline-flex' && cs.display !== 'flex') {
      el.style.display = cs.display === 'block' || cs.display === 'grid' ? 'flex' : 'inline-flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
    }
    if (!el.style.gap && (parseFloat(cs.columnGap) || 0) === 0) el.style.gap = '8px';
    /* un seul pictogramme : on remplace la flèche existante par la patte */
    el.querySelectorAll(':scope > span[aria-hidden] > svg').forEach(function (s) { s.parentNode.parentNode.removeChild(s.parentNode); });
    var paw = document.createElement('span');
    paw.className = 'wl-paw'; paw.setAttribute('aria-hidden', 'true'); paw.innerHTML = PAW;
    el.appendChild(paw);
  }
  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.wl-root a, .wl-root button, .wlq-cta, .wl-btn');
    for (var i = 0; i < nodes.length; i++) { if (isCta(nodes[i])) decorate(nodes[i]); }
  }
  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function () {
    scan(document);
    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scan(document); }, 60); })
        .observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { scan(document); });
  });
})();
